import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    HomeIcon,
    UsersIcon,
    GlobeAltIcon,
    ChartPieIcon,
    CreditCardIcon,
    ChartBarIcon,
    Cog6ToothIcon,
    DocumentTextIcon
} from '@heroicons/react/24/outline';

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
    
    // Liste des menus avec leurs liens et icônes
    const menuItems = [
        { name: 'Tableau de bord', path: '/admin', icon: HomeIcon, end: true }, // end: true pour exact match sur /admin
        { name: 'Utilisateurs', path: '/admin/users', icon: UsersIcon },
        { name: 'Domaines', path: '/admin/domains', icon: GlobeAltIcon },
        { name: 'Pré-rapports', path: '/admin/reports', icon: DocumentTextIcon },
        { name: 'Quotas', path: '/admin/quotas', icon: ChartPieIcon },
        { name: 'Paiements', path: '/admin/payments', icon: CreditCardIcon },
        { name: 'Statistiques', path: '/admin/stats', icon: ChartBarIcon },
        { name: 'Paramètres', path: '/admin/settings', icon: Cog6ToothIcon },
    ];

    return (
        <>
            {/* Overlay mobile (fond noir transparent quand le menu est ouvert sur mobile) */}
            <div
                onClick={() => setSidebarOpen(false)}
                className={`fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden ${
                    sidebarOpen ? 'block' : 'hidden'
                }`}
            ></div>

            {/* Sidebar Container */}
            <aside
                className={`fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition-transform duration-300 transform border-r border-gray-800 bg-[#1c2143] lg:translate-x-0 lg:static lg:inset-0 ${
                    sidebarOpen ? 'translate-x-0 ease-out' : '-translate-x-full ease-in'
                }`}
            >
                {/* En-tête de la Sidebar (Optionnel si tu veux répéter le titre, sinon juste de l'espace) */}
                <div className="flex items-center justify-center h-16 bg-[#151934] shadow-md">
                    <span className="text-white text-lg font-bold tracking-wider uppercase">
                        Menu Admin
                    </span>
                </div>

                {/* Navigation */}
                <nav className="mt-5 px-4 space-y-2">
                    {menuItems.map((item) => (
                        <NavLink
                            key={item.name}
                            to={item.path}
                            end={item.end} // Important pour que "Tableau de bord" ne soit pas toujours allumé
                            onClick={() => setSidebarOpen(false)} // Ferme le menu sur mobile au clic
                            className={({ isActive }) =>
                                `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 group ${
                                    isActive
                                        ? 'bg-[#Ceaa5b]/10 text-[#Ceaa5b] border border-[#Ceaa5b]/20 shadow-sm' // Style Actif (Doré)
                                        : 'text-gray-400 hover:bg-white/5 hover:text-white' // Style Inactif
                                }`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <item.icon
                                        className={`w-5 h-5 mr-3 transition-colors ${
                                            isActive ? 'text-[#Ceaa5b]' : 'text-gray-500 group-hover:text-white'
                                        }`}
                                    />
                                    {item.name}
                                </>
                            )}
                        </NavLink>
                    ))}
                </nav>

                {/* Pied de page Sidebar (Optionnel : Version v1.0) */}
                <div className="absolute bottom-0 w-full p-4 border-t border-gray-800">
                    <p className="text-xs text-center text-gray-600">
                        Version 1.0.0
                    </p>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;